import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import TrackingLinkShow from '../components/TrackingLinkShow/TrackingLinkShow';
import { actions } from '../../broker/redux/brokerActions';
import Loader from '../../../common/components/Loader/Loader';
import InternalContainer from '../../../modules/layout/containers/Internal';
import InternalTabs from '../../layout/components/InternalTabs/InternalTabs';
import getIncludedResource from '../../../helpers/getIncludedResource';
import displayName from '../../../helpers/displayName';
import { brokerStatuses } from '../../../schemas/broker';
import BrokerCommissionsShow from '../../broker/components/BrokerCommissionsShow/BrokerCommissionsShow';
import { Label } from 'react-bootstrap';
import { get } from 'lodash';
import BrokerTheme from '../../broker/components/BrokerTheme/BrokerTheme';
import BrokerNotes from '../../broker/components/BrokerNotes/BrokerNotes';
import BrokerContent from '../../broker/components/BrokerContent/BrokerContent';
import TrackingLinkLabel from '../components/TrackingLinkLabel/TrackingLinkLabel';
import { Box } from '../../../common/components';

const labelStyle = (brokerStatus) => {
  switch (brokerStatus) {
    case 'Pending':
    case 'Awaiting Approval':
      return 'warning';

    case 'Live':
      return 'success';
    case 'Inactive':
    case 'Cancelled':
      return 'danger';

    default:
      return 'info';
  }
};

const Container = ({ status, name, children }) => (
  <Box className={'tracking-link-show'}>
    <TrackingLinkLabel status={status || ''} name={name || 'New Tracking Link'} />
    {children}
  </Box>
);

const tabs = (brokerLabel, resource, channels, refreshData) => {
  const resourceAttributes = resource?.data?.attributes ?? {};
  const { name, status } = resourceAttributes;
  const channel = getIncludedResource(resource.data, resource.included, 'channel');
  const hasWhiteLabel = channel.data.attributes !== undefined;

  const resourceName = hasWhiteLabel
    ? channel.data.attributes.name
    : name + ' (No Whitelabel)';

  const tabs = [
    {
      permissions: ['broker.view'],
      title: 'Details',
      content: (
        <Container status={status || ''} name={name || 'New Tracking Link'}>
          <TrackingLinkShow resource={resource} onRefreshData={refreshData} />
        </Container>
      ),
    },
    {
      permissions: ['broker.edit'],
      title: 'Insurers',
      content: (
        <Container status={status || ''} name={name || 'New Tracking Link'}>
          <BrokerCommissionsShow
            resource={resource}
            commissions={getIncludedResource(
              resource.data,
              resource.included,
              'active_commissions',
            )}
          />
        </Container>
      ),
    },
  ];

  if (resource.data.attributes.broker_type === 'introducer') {
    tabs.push({
      permissions: ['broker.approve'],
      title: 'White Label',
      content: (
        <>
          <Container status={resourceName || ''} name={name || 'New Tracking Link'}>
            <BrokerTheme
              resource={resource}
              brokerLabel={brokerLabel}
              isTrackingLink={true}
              brokerId={resource.data.id}
            />
          </Container>
        </>
      ),
    });
  }
  if (resource.data.attributes.broker_type === 'introducer') {
    tabs.push({
      permissions: ['broker.approve'],
      title: 'Email and Letter Content',
      content: (
        <>
          <Container status={status || ''} name={name || 'New Tracking Link'}>
            <BrokerContent
              resource={resource}
              renewalsEnabled={resource.data.attributes.metadata.renewals_enabled}
              brokerLabel={brokerLabel}
              brokerId={resource.data.id}
            />
          </Container>
        </>
      ),
    });
  }

  tabs.push({
    permissions: ['broker.approve'],
    title: 'Notes',
    content: (
      <>
        <Container status={status || ''} name={name || 'New Tracking Link'}>
          <BrokerNotes resource={resource} isTrackingLink={true} />
        </Container>
      </>
    ),
  });

  return tabs;
};

const TrackingLinkShowContainer = ({ params: { id }, broker, getBroker }) => {
  useEffect(
    () => {
      getBroker(id);
      //  getAllProducts();
    },
    [getBroker, id],
  );

  const resource = broker.resources[id];
  if (!resource) {
    return <Loader />;
  }

  const refreshData = () => {
    return getBroker(id);
  };

  const channels = getIncludedResource(resource.data, resource.included, 'channels');
  const brokerStatus = brokerStatuses[get(resource, 'data.attributes.status', 'applied')];

  const brokerLabel = (
    <Label className="pull-right" bsStyle={labelStyle(brokerStatus)}>
      {displayName(brokerStatus)}
    </Label>
  );

  return (
    <InternalContainer>
      <InternalTabs
        id={'TrackingLinkTabs'}
        tabs={tabs(brokerLabel, resource, channels, refreshData)}
      />
    </InternalContainer>
  );
};

export default connect(
  (state) => {
    return {
      broker: state.broker,
    };
  },
  {
    getBroker: actions.getBroker,
  },
)(TrackingLinkShowContainer);
